import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Marketing from "@/pages/Marketing";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/components/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST (synchronously during render) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Marketing />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
